import React from 'react';
import GalleryCategories from '../components/GalleryCategories';

export default function GalleryCategoriesPage({ language }) {
  return <GalleryCategories language={language} />;
}
